export interface ICoordinates {
  latitude:number,
  longitude:number
}

export default function LocationFormatter($filter:ng.IFilterService) {
  const numberFilter:ng.IFilterNumber = $filter('number');
  return (input:ICoordinates) => {
    const lat = numberFilter(input.latitude);
    const lng = numberFilter(input.longitude);
    return `${lat}, ${lng}`;
  }
}

LocationFormatter.$inject = ['$filter'];



/** WEBPACK FOOTER **
 ** ./app/utils/location.formatter.ts
 **/